/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { ResendInviteOptions, ResendInviteResponses } from '../../models/ResendInvite'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Resend Invite
 * {@link /org/invite/:invite_id/resend}
 */
export function resendInvite<ThrowOnError extends boolean = true>(options: Options<ResendInviteOptions, ThrowOnError>): Promise<UnwrappedResult<ResendInviteResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/org/invite/{invite_id}/resend', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<ResendInviteResponses, ThrowOnError>>
}
